export const APP_NAME = 'SchooLinks';
export const SERVICE_TIMEOUT = 120000;
export const JWT = 'jwt';
export const REFRESH_TOKEN = 'jwt_refresh';
export const DEMO_STUDENT_JWT = `demo_student_${JWT}`;
export const DEMO_STUDENT_REFRESH_TOKEN = `demo_student_${REFRESH_TOKEN}`;
export const SCHOOL_ID = 'school_id';
export const SCHOOLINKS_DOMAIN = 'schoolinks.com';
export const SHOULD_REDIRECT = 'should_redirect';
export const STUDENT_SCHOOL_ID = 'student_school_id';
export const STUDENT_ID = 'student_id';
export const DISTRICT_ID = 'district_id';
export const USER_TYPE = 'user_type';
export const USER_ID = 'user_id';
export const USER_ID_QUERY_PARAM = 'uid';
export const MIN_PASSWORD_CHAR_LIMIT = 8;
export const MAX_PASSWORD_CHAR_LIMIT = 20;
